import { inject } from "vue";
import { InklineKey } from "@inkline/inkline/constants";
export function useInkline() {
  return inject(InklineKey);
}
